export default "__VITE_PUBLIC_ASSET__37a2e427__"